import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Surprise, TitleWithTextTitle } from "../../../../Constants/Constants";
import { TitleWithTextSubTitle } from "../../../../Data/BonusUi/SweetAlert";

const TitleWithText = () => {
  const handleAlert = () => Swal.fire("It's Magic!", "Thank you for visiting Moscow Theme");

  return (
    <Col xxl="3" lg="4" sm="6" xs="12">
      <Card className="height-equal">
        <CommonCardHeader title={TitleWithTextTitle} span={TitleWithTextSubTitle} />
        <CardBody className="btn-showcase">
          <Btn color="secondary" className="sweet-2" onClick={handleAlert}>
            {Surprise}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};
export default TitleWithText;
